import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import { ChevronDoubleDownIcon, ChevronDoubleUpIcon } from '@heroicons/react/24/outline';
import Audio from '../shared/audio';
import Segment from '../shared/segment';
import { useBooleanState } from '../../hooks/index/use-boolean-state';
import { VoiceType } from '../../api/voice';
import 'swiper/css';
import 'swiper/css/navigation';

export type VoicesPropsType = { voices: VoiceType[] };

function Voices({ voices }: VoicesPropsType) {
  const { value: visible, toggle: toggleVisible } = useBooleanState(true);
  if (voices.length === 0) return null;

  function renderContent() {
    if (voices.length === 1) {
      const voice = voices[0];
      return (
        <>
          <Audio
            noDownload
            caption={`${voice.name}:`}
            src={process.env.REACT_APP_MEDIA_BASE_URL + voice.file}
          />
          <ChevronDoubleDownIcon
            width={20}
            height={20}
            className='mx-auto mt-2'
            onClick={toggleVisible}
          />
        </>
      );
    }

    return (
      <Swiper
        // @ts-ignore
        navigation
        modules={[Navigation]}
      >
        {voices.map(voice => (
          <SwiperSlide key={voice.id}>
            <Audio
              noDownload
              caption={`${voice.name}:`}
              src={process.env.REACT_APP_MEDIA_BASE_URL + voice.file}
            />
            <ChevronDoubleDownIcon
              width={20}
              height={20}
              className='mx-auto mt-2'
              onClick={toggleVisible}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    );
  }

  return (
    <Segment
      bg
      noPad
      noMargin
      color='purple'
      className={
        visible
          ? 'container fixed bottom-0 py-2'
          : 'fixed right-1/2 bottom-0 translate-x-1/2 py-2 px-8'
      }
    >
      <div className={!visible ? 'hidden' : ''}>{renderContent()}</div>
      {!visible && (
        <ChevronDoubleUpIcon width={20} height={20} className='mx-auto' onClick={toggleVisible} />
      )}
    </Segment>
  );
}

export default Voices;
